import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { id: "user-preferences-edition" }
const _hoisted_2 = { class: "profile-form form-box" }
const _hoisted_3 = ["onSubmit"]
const _hoisted_4 = { class: "form-items" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "form-items" }
const _hoisted_8 = { class: "form-items" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "form-items" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "form-buttons" }
const _hoisted_15 = {
  class: "confirm",
  type: "submit"
}

import { ComputedRef, computed, reactive, onMounted, onUnmounted } from 'vue'

  import TimezoneDropdown from '@/components/User/ProfileEdition/TimezoneDropdown.vue'
  import { AUTH_USER_STORE, ROOT_STORE } from '@/store/constants'
  import { IUserProfile, IUserPreferencesPayload } from '@/types/user'
  import { useStore } from '@/use/useStore'
  import { availableLanguages } from '@/utils/locales'

  interface Props {
    user: IUserProfile
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    user: null
  },
  setup(__props: any) {

const props = __props as {
    user: IUserProfile
  }

  

  const store = useStore()

  const userForm: IUserPreferencesPayload = reactive({
    imperial_units: false,
    language: '',
    timezone: 'Europe/Paris',
    weekm: false,
  })
  const weekStart = [
    {
      label: 'MONDAY',
      value: true,
    },
    {
      label: 'SUNDAY',
      value: false,
    },
  ]
  const imperialUnits = [
    {
      label: 'IMPERIAL',
      value: true,
    },
    {
      label: 'METRIC',
      value: false,
    },
  ]
  const loading = computed(
    () => store.getters[AUTH_USER_STORE.GETTERS.USER_LOADING]
  )
  const errorMessages: ComputedRef<string | string[] | null> = computed(
    () => store.getters[ROOT_STORE.GETTERS.ERROR_MESSAGES]
  )

  onMounted(() => {
    if (props.user) {
      updateUserForm(props.user)
    }
  })

  function updateUserForm(user: IUserProfile) {
    userForm.imperial_units = user.imperial_units ? user.imperial_units : false
    userForm.language = user.language ? user.language : 'en'
    userForm.timezone = user.timezone ? user.timezone : 'Europe/Paris'
    userForm.weekm = user.weekm ? user.weekm : false
  }
  function updateProfile() {
    store.dispatch(AUTH_USER_STORE.ACTIONS.UPDATE_USER_PREFERENCES, userForm)
  }
  function updateTZ(value: string) {
    userForm.timezone = value
  }

  onUnmounted(() => {
    store.commit(ROOT_STORE.MUTATIONS.EMPTY_ERROR_MESSAGES)
  })

return (_ctx: any,_cache: any) => {
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(errorMessages))
        ? (_openBlock(), _createBlock(_component_ErrorMessage, {
            key: 0,
            message: _unref(errorMessages)
          }, null, 8, ["message"]))
        : _createCommentVNode("", true),
      _createElementVNode("form", {
        onSubmit: _withModifiers(updateProfile, ["prevent"])
      }, [
        _createElementVNode("label", _hoisted_4, [
          _createTextVNode(_toDisplayString(_ctx.$t('user.PROFILE.LANGUAGE')) + " ", 1),
          _withDirectives(_createElementVNode("select", {
            id: "language",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(userForm).language) = $event)),
            disabled: _unref(loading)
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableLanguages), (lang) => {
              return (_openBlock(), _createElementBlock("option", {
                value: lang.value,
                key: lang.value
              }, _toDisplayString(lang.label), 9, _hoisted_6))
            }), 128))
          ], 8, _hoisted_5), [
            [_vModelSelect, _unref(userForm).language]
          ])
        ]),
        _createElementVNode("label", _hoisted_7, [
          _createTextVNode(_toDisplayString(_ctx.$t('user.PROFILE.TIMEZONE')) + " ", 1),
          _createVNode(TimezoneDropdown, {
            input: _unref(userForm).timezone,
            disabled: _unref(loading),
            onUpdateTimezone: updateTZ
          }, null, 8, ["input", "disabled"])
        ]),
        _createElementVNode("label", _hoisted_8, [
          _createTextVNode(_toDisplayString(_ctx.$t('user.PROFILE.FIRST_DAY_OF_WEEK')) + " ", 1),
          _withDirectives(_createElementVNode("select", {
            id: "weekm",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(userForm).weekm) = $event)),
            disabled: _unref(loading)
          }, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(weekStart, (start) => {
              return _createElementVNode("option", {
                value: start.value,
                key: start.value
              }, _toDisplayString(_ctx.$t(`user.PROFILE.${start.label}`)), 9, _hoisted_10)
            }), 64))
          ], 8, _hoisted_9), [
            [_vModelSelect, _unref(userForm).weekm]
          ])
        ]),
        _createElementVNode("label", _hoisted_11, [
          _createTextVNode(_toDisplayString(_ctx.$t('user.PROFILE.UNITS.LABEL')) + " ", 1),
          _withDirectives(_createElementVNode("select", {
            id: "imperial_units",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(userForm).imperial_units) = $event)),
            disabled: _unref(loading)
          }, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(imperialUnits, (unit) => {
              return _createElementVNode("option", {
                value: unit.value,
                key: unit.value
              }, _toDisplayString(_ctx.$t(`user.PROFILE.UNITS.${unit.label}`)), 9, _hoisted_13)
            }), 64))
          ], 8, _hoisted_12), [
            [_vModelSelect, _unref(userForm).imperial_units]
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("button", _hoisted_15, _toDisplayString(_ctx.$t('buttons.SUBMIT')), 1),
          _createElementVNode("button", {
            class: "cancel",
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$router.push('/profile/preferences')), ["prevent"]))
          }, _toDisplayString(_ctx.$t('buttons.CANCEL')), 1)
        ])
      ], 40, _hoisted_3)
    ])
  ]))
}
}

})